import React from 'react'

import RecentStats from '@components/Stats/RecentStats'
import AllLangStats from '@components/Stats/AllLangStats'

export default function StatsPage({
  counts,
  scrapes,
}){
  return (
      <main > 
        {counts &&
          <AllLangStats counts={counts} />
        }
        {scrapes &&
          <RecentStats scrapes={scrapes}  />
        }   
      </main>
    )
}
